import { useState, useCallback } from 'react';

/**
 * Shared behavior for the writing-task prompt panel: expanded by default,
 * auto-collapses to a "Show more" summary on the textarea's first focus
 * (the student has read it by then), re-expandable at any time by tapping.
 */
export function useCollapseOnFirstFocus() {
  const [collapsed, setCollapsed] = useState(false);

  const expand = useCallback(() => setCollapsed(false), []);

  const handleTextareaFocus = useCallback(() => {
    setCollapsed(true);
  }, []);

  return { collapsed, expand, handleTextareaFocus };
}
